import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  TEMPLATE: `${cleanedFilename(__filename)}-template`,
};
